module.exports = __webpack_public_path__ + "img/quick-label-print-icon-orange.44b67ec3.svg";